import { IconImageProps } from "../interface"

export const IconImage = ({ imageUrl, height = '24px', width = '24px' }: IconImageProps) => {
  return (
    <img
      src={imageUrl}
      alt=""
      style={{
        width,
        height,
      }}
    />
  );
};

export const IconNestedListItemImage = ({ imageUrl, height = '7px', width = '7px' }: IconImageProps) => {
  return (
    <img
      src={imageUrl}
      alt=""
      style={{
        width,
        height,
      }}
    />
  );
};
